module.exports = __webpack_public_path__ + "static/media/ecommerce-cart-logo.126ea954.png";